function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from "react";
import { UI } from "../../../builderUiTheme";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function normalizeHex(val) {
  if (!val || typeof val !== "string") return "#ffffff";
  var trimmed = val.trim().toLowerCase();
  if (trimmed === "transparent") return "#ffffff";
  if (trimmed.startsWith("#")) {
    var hex = trimmed.substring(1);
    if (hex.length === 3) {
      return "#" + hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length === 6 && /^[0-9a-f]{6}$/.test(hex)) {
      return trimmed;
    }
  } else {
    if (trimmed.length === 3 && /^[0-9a-f]{3}$/.test(trimmed)) {
      return "#" + trimmed[0] + trimmed[0] + trimmed[1] + trimmed[1] + trimmed[2] + trimmed[2];
    }
    if (trimmed.length === 6 && /^[0-9a-f]{6}$/.test(trimmed)) {
      return "#" + trimmed;
    }
  }
  return "#ffffff";
}
function isCommitableColor(val) {
  if (!val || typeof val !== "string") return false;
  var trimmed = val.trim().toLowerCase();
  if (trimmed === "transparent") return true;
  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/.test(trimmed)) return true;
  if (/^([0-9a-f]{3}|[0-9a-f]{6})$/.test(trimmed)) return true;
  return false;
}
function toCommittedColor(val) {
  var trimmed = val.trim();
  if (trimmed.toLowerCase() === "transparent") return "transparent";
  return normalizeHex(trimmed.startsWith("#") ? trimmed : "#".concat(trimmed));
}
export default function ColorPickerField(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  var hexValue = normalizeHex(value);
  var colorRef = useRef(null);
  var _useState = useState(value || ""),
    _useState2 = _slicedToArray(_useState, 2),
    textValue = _useState2[0],
    setTextValue = _useState2[1];
  useEffect(function () {
    setTextValue(value || "");
  }, [value]);
  var commit = function commit(raw) {
    if (!isCommitableColor(raw)) {
      setTextValue(value || "");
      return;
    }
    var committed = toCommittedColor(raw);
    setTextValue(committed);
    if (committed !== value) {
      _onChange(committed);
    }
  };
  var stopKeys = function stopKeys(event) {
    event.stopPropagation();
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 8
    },
    children: [/*#__PURE__*/_jsx("label", {
      style: {
        fontSize: 14,
        fontWeight: 600,
        color: "#4b5563"
      },
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        gap: 8,
        alignItems: "center"
      },
      children: [/*#__PURE__*/_jsx("div", {
        onClick: function onClick() {
          return colorRef.current && colorRef.current.click();
        },
        style: {
          width: 36,
          height: 36,
          borderRadius: 6,
          background: hexValue,
          border: "1px solid ".concat(UI.inputBorder),
          boxShadow: UI.shadow,
          cursor: "pointer",
          position: "relative",
          flexShrink: 0,
          overflow: "hidden"
        },
        children: /*#__PURE__*/_jsx("input", {
          ref: colorRef,
          type: "color",
          value: hexValue,
          onChange: function onChange(e) {
            return _onChange(e.target.value);
          },
          tabIndex: -1,
          style: {
            position: "absolute",
            inset: 0,
            opacity: 0,
            width: "100%",
            height: "100%",
            cursor: "pointer",
            padding: 0,
            border: "none"
          }
        })
      }), /*#__PURE__*/_jsx("input", {
        type: "text",
        spellCheck: false,
        autoComplete: "off",
        value: textValue,
        onMouseDown: stopKeys,
        onKeyDown: stopKeys,
        onKeyUp: stopKeys,
        onChange: function onChange(e) {
          return setTextValue(e.target.value);
        },
        onBlur: function onBlur(e) {
          return commit(e.target.value);
        },
        onKeyPress: function onKeyPress(e) {
          if (e.key === "Enter") {
            e.preventDefault();
            commit(e.target.value);
            e.target.blur();
          }
        },
        placeholder: "#334155",
        style: {
          width: "100%",
          background: UI.inputBg,
          border: "1px solid ".concat(UI.inputBorder),
          borderRadius: 6,
          color: UI.text,
          padding: "8px 12px",
          fontSize: 14,
          outline: "none",
          boxSizing: "border-box",
          fontFamily: "DM Sans, sans-serif",
          fontWeight: 500,
          flex: 1
        }
      }), value && value !== "transparent" && /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: function onClick() {
          return _onChange("transparent");
        },
        style: {
          background: "rgba(0, 0, 0, 0.1)",
          border: "none",
          color: '#101828',
          fontSize: 14,
          cursor: "pointer",
          padding: "8px 10px",
          fontFamily: "DM Sans, sans-serif",
          fontWeight: 500,
          borderRadius: 6
        },
        title: "Set transparent",
        children: "Clear"
      })]
    })]
  });
}